module.exports = __webpack_public_path__ + "static/media/Theon Greyjoy 3.c4d57a25.jpg";